import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthService } from "./Services/auth.service";
import { TokenService } from "./Services/token.service";
import { AuthModalService } from "./Services/auth-modal.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private tokenService: TokenService,
    private router: Router,
    private authModalService: AuthModalService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): boolean {
    if (this.tokenService.getRefreshToken()) {
      return true;
    }

    if (this.authModalService.consumeAuthCancelled()) {
      this.router.navigateByUrl(this.authModalService.publicFallbackUrl, {
        replaceUrl: true,
      });
      return false;
    }

    this.authService.redirectUrl = url || "/";
    try {
      localStorage.setItem("returnUrl", url || "/");
    } catch {
      /* ignore */
    }

    this.router.navigate(["/login"], {
      queryParams: { returnUrl: url || "/" },
    });
    return false;
  }
}
